export default "__VITE_ASSET__Bd42Pb5u__"